import { createContext } from "react";
import useAttachmentTypes from "../hooks/data/useAttachmentTypes";

export interface IAttachmentTypesContext extends ReturnType<typeof useAttachmentTypes> {

};

const AttachmentTypesContext = createContext<IAttachmentTypesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default AttachmentTypesContext